var _g, _defs;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgCampaignsFlag = function SvgCampaignsFlag(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.8703 5.38007C17.7392 5.39912 17.6 5.4189 17.452 5.43429C16.8937 5.49949 15.6424 5.63503 14.8877 5.63503C13.7733 5.58711 12.6663 5.42931 11.5828 5.16394C10.4635 4.90974 9.32199 4.76522 8.17459 4.73242C5.79792 4.73242 4.99055 5.19911 4.9063 5.24893L4.73267 5.36102V18.9807C4.74109 19.1308 4.80614 19.2721 4.91468 19.376C5.02323 19.48 5.16717 19.5389 5.31746 19.5409C5.46774 19.5428 5.6966 19.4877 5.8078 19.3866C5.91901 19.2855 5.98771 19.1459 6.00003 18.9961C6.00003 18.9961 5.31746 12.8742 6.50003 12.8742C7.29184 12.7117 7.36601 12.6164 8.17386 12.5892C9.27017 12.6844 10.3548 12.8846 11.4128 13.187C12.5685 13.4632 13.751 13.6118 14.939 13.6303C15.9557 13.616 16.9702 13.5311 17.9751 13.3761C18.0525 13.3693 18.1248 13.3346 18.1787 13.2786C18.2326 13.2226 18.2644 13.1489 18.2681 13.0713V5.68485C18.2645 5.63769 18.251 5.59183 18.2285 5.55025C18.2059 5.50867 18.1749 5.47231 18.1373 5.44354C18.0998 5.41478 18.0566 5.39426 18.0106 5.38332C17.9646 5.37239 17.9168 5.37128 17.8703 5.38007Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 1.6,
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 16.2689,
    fill: "white",
    transform: "translate(4 4)"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCampaignsFlag, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/campaigns-flag.84b1dee1.svg";
export { ForwardRef as ReactComponent };